import FetchUtils from './utils/FetchUtils';
import RcsUtils from './utils/RcsUtils';
import { EventHelper } from './utils/EventUtils';
import CONFIG from 'config';

class InfiniteLink {
  constructor(obj) {
    this.selector = '.md_is_artlist';
    this.apiPrefix = CONFIG.apiPrefix;
    this.footer = document.querySelector('#main_footer');
    this.item = {
      cta: '.md_is_artlist .title_art a',
      art: '.IS_item'
    };
    this.incError = 0;
    this.parent = obj.parent || null;
    this.firstDelta = 8;
    this.delta = 5;
    this.count = 0;
    this.stopped = !1;
    this.crossingEl = document.querySelector('[data-crossing-el]');
    console.log(this.crossingEl);
  }

  init() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop >= 300 && this.parent.count > 0) {
      this.compose();
    }

    EventHelper.addEventListener(window, 'scroll.initScroller', () => {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 300 || this.parent.count < 1) {
        return true;
      }

      EventHelper.removeEventListener(window, 'scroll.initScroller');
      this.compose();
    });
  }

  nextItems(artList) {
    if (this.parent.isBlocked()) {
      return;
    }

    this.parent.block('itemLoad', true);

    if (typeof artList === 'undefined') {
      let nodes = Array.from(document.querySelectorAll('.md_is_artlist_container'));
      artList = nodes[nodes.length - 1];
    }

    artList.querySelector(this.selector).classList.add('loading');

    let IDsLen = this.parent.IDs.length;
    let _uuid;
    let _c = this.count;
    let _allLoad = 0;
    let notMoreThenDelta = false;

    if (IDsLen < this.firstDelta) {
      notMoreThenDelta = true;
      this.firstDelta = IDsLen;
    }

    for (let i = _c; i < this.firstDelta + _c; i++) {
      if (i > IDsLen) {
        return this.end();
      }

      _uuid = this.parent.IDs[i];

      this.methView(
        {
          uuid: _uuid,
          art: this.parent.data[_uuid]
        },
        tmpl => {
          this.onLoad(tmpl, artList);
        },
        () => {
          _allLoad++;

          if (_allLoad >= 2) {
            this.onComplete(artList);
          }

          if (notMoreThenDelta) {
            this.end();
          }
        }
      );

      this.count++;
    }
    this.firstDelta = this.delta;
  }

  onComplete(artList) {
    setTimeout(() => {
      this.parent.block('itemLoad', false);
      artList.querySelector(this.selector).classList.remove('loading');
    }, 200);
  }

  end() {
    EventHelper.removeEventListener(window, 'scroll.initScroller');
    this.parent.block('itemLoad', false);
    if (this.stopped) {
      return;
    }

    this.stopped = !0;

    let nodes = Array.from(document.querySelectorAll('.md_is_artlist_container'));
    let artList = nodes[nodes.length - 1];
    let loaderElement = artList.querySelector('.md_is_artlist_loader');
    loaderElement.style.display = 'none';

    let itemArt = artList.querySelector(this.item.art);
    if (itemArt === null) {
      artList.style.display = 'none';
    }
  }

  makeViewUrl(_url) {
    let suffix = this.parent.isLocal ? '' : '_Sezioni';
    let regexp = new RegExp(/.*\/\/[^\/]*\/(.*)\.shtml/);

    if (_url.match(regexp)) {
      _url = _url.replace(regexp, (m, s1) => {
        return `/${s1}_ART_BTM${suffix}.shtml`;
      });

      return _url;
    }
  }

  onLoad(tmpl, artList) {
    let loaderElement = artList.querySelector('.md_is_artlist_loader');
    let element = document.createElement(null);
    element.innerHTML = tmpl;
    loaderElement.insertAdjacentHTML('beforebegin', tmpl);

    setTimeout(() => {
      let parentElement = loaderElement.parentNode;
      let el = parentElement.querySelector('article:not(.loaded)');
      if (el !== null) {
        el.classList.add('loaded');
      }
    }, 200);
  }

  imageParser(image) {
    let imageSuffix = this.parent.isLocal
      ? '-' + window.location.hostname.substring(0, window.location.hostname.indexOf('.'))
      : '';
    image = `//images2${imageSuffix}.corriereobjects.it/${image}`;
    return image;
  }

  methView(data, success, callback) {
    if (data.id === 'undefined' || typeof data.art === 'undefined') {
      callback();

      return;
    }

    let viewUrl = this.makeViewUrl(data.art.url);

    if (viewUrl) {
      let url = `https://${
        window.location.hostname
      }/includes2013/SSI/_templates/_modules/IS_view_loader.shtml?url=${viewUrl}`;

      RcsUtils.fetchText(
        url,
        _view => {
          let view = document.createElement(null);
          view.innerHTML = FetchUtils.arrayBufferToString(_view);

          if (RcsUtils.getDevice() === 'mobile') {
            let headerElement = view.querySelector('header');
            if (headerElement !== null) {
              let previousHtml = headerElement.innerHTML;
              let image = this.imageParser(data.art.image);
              let figureHtml = `<figure><img alt='' src='${image}' /></figure>`;
              headerElement.innerHTML = `${figureHtml}${previousHtml}`;
            }
          }

          let itemArtElement = view.querySelector(this.item.art);
          if (itemArtElement !== null) {
            view.querySelector(this.item.art).setAttribute('data-uuid', data.uuid);
          }

          let html = view.querySelector('span').innerHTML;

          success(html);
          callback(html);
        },
        () => {
          callback();
        }
      );
    }

    return true;
  }

  compose() {
    this.nextItems();

    EventHelper.addEventListener(window, 'scroll.infiniteLink', () => {
      const crossElement = document.querySelector('[data-crossing-el]') || this.footer;
      if (!crossElement) return;
      let scrollTopFooter = crossElement.offsetTop;
      let isBlocked = this.parent.isBlocked();

      if (!isBlocked && scrollTopFooter <= window.pageYOffset + window.innerHeight) {
        this.nextItems();
      }
    });
  }
}

module.exports = InfiniteLink;



// WEBPACK FOOTER //
// ./src/rcs_cor_continous-related-link/InfiniteLink.js